import { render, staticRenderFns } from "./InventoryStats.vue?vue&type=template&id=70648f1c&scoped=true&"
import script from "./InventoryStats.vue?vue&type=script&lang=js&"
export * from "./InventoryStats.vue?vue&type=script&lang=js&"
import style0 from "./InventoryStats.vue?vue&type=style&index=0&id=70648f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70648f1c",
  null
  
)

export default component.exports